var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "u-flex u-align-center u-margin-left-toolbar" },
    [
      _c("span", [_vm._v(_vm._s(_vm.$t("tables.limitSelectorLabel")))]),
      _c("gl-select", {
        directives: [
          {
            name: "skeletor",
            rawName: "v-skeletor:onChange",
            value: _vm.setNumPage,
            expression: "setNumPage",
            arg: "onChange"
          }
        ],
        staticClass: "u-margin-left-toolbar",
        attrs: {
          id: "admin.limitSelector",
          options: JSON.stringify(_vm.dataList),
          value: JSON.stringify(_vm.selectedOption),
          separator: true,
          "auto-width": true
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }